import { ModalCloseButton, Flex, styled, ModalBody } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const CarouselModalStyles = {
  Fluid: styled(Flex, {
    maxWidth: '794px',
    height: '724px',
    margin: '0 auto',
    borderRadius: '8px',
    overflow: 'hidden',
    img: {
      width: '100%',
      height: '100%',
    },
  }),
  FluidMobile: styled(Flex, {
    maxWidth: '794px',
    height: '300px',
    margin: '0 auto',
    borderRadius: '8px',
    overflow: 'hidden',
    img: {
      width: '100%',
      height: '100%',
    },
  }),
  CloseButton: styled(ModalCloseButton, {
    borderRadius: '50%',
    background: `${theme.colors.build.lightDark2}`,

    svg: {
      color: `${theme.colors.action.navigation.standard.static}`,
      path: {
        fill: `${theme.colors.action.navigation.standard.static}`,
      },
    },
  }),

  Body: styled(ModalBody, {
    overflowX: 'hidden',
  }),
};
